export enum OnboardingSteps {
  ADD_INTERSECTIONALITY_DATA = 'add_intersectionality_data',
  BOARD_REGISTRATION_NUMBER = 'board_registration_number',
  EMAIL_CONFIRMATION = 'email_confirmation',
  POST_REGISTRATION_DATA = 'post_registration_data',
}

export enum ProfileStatus {
  PENDING = 'pending',
  IN_REVIEW = 'in_review',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  DELETED = 'deleted',
}

/** APPOINTMENTS */
/** Status de Agendamento */
export enum AppointmentStatus {
  CONFIRMED = 'confirmed',
  PENDING = 'pending',
  CANCELED = 'canceled',
}

/** Tipos de Consulta */
export enum AppointmentType {
  IN_PERSON = 'in_person',
  ONLINE = 'online',
}

/** Status de Pagamento */
export enum PaymentStatus {
  Pending = 'pending',
  Payed = 'payed',
  Failed = 'failed',
}

/** Métodos de Pagamento */
export enum PaymentMethod {
  CreditCard = 'credit_card',
  Pix = 'pix',
}
